import { render, staticRenderFns } from "./DimensionsField.vue?vue&type=template&id=3c68533c&"
import script from "./DimensionsField.vue?vue&type=script&lang=ts&"
export * from "./DimensionsField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports